import { render, staticRenderFns } from "./AppBoardHeader.vue?vue&type=template&id=8dc00a28&scoped=true"
import script from "./AppBoardHeader.vue?vue&type=script&lang=js"
export * from "./AppBoardHeader.vue?vue&type=script&lang=js"
import style0 from "./AppBoardHeader.vue?vue&type=style&index=0&id=8dc00a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc00a28",
  null
  
)

export default component.exports